import { PayloadAction } from "@reduxjs/toolkit";
import { getTimeOffs_timeOffs_timeOffs } from "../../../../__generated/getTimeOffs";
import { LeavesState } from "../leavesSlice";

const selectedLeaveSetted = (
  state: LeavesState,
  { payload }: PayloadAction<getTimeOffs_timeOffs_timeOffs>
) => {
  state.selectedTimeOff = payload;
};

export default selectedLeaveSetted;
